// Supabase is dynamically imported to keep it off the landing critical path.
import { currentVariant, EXPERIMENT_ID } from "./experiment";

const SESSION_KEY = "piefolio_session_id";
const CONSENT_KEY = "piefolio_cookie_consent";
const EXPOSURE_KEY = "piefolio_exp_exposure";

function getSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id =
      (crypto?.randomUUID?.() as string) ||
      `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

function hasConsent(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CONSENT_KEY) === "accepted";
}

export type EventName =
  | "store_click"
  | "cta_click"
  | "language_change"
  | "section_view"
  | "faq_open"
  | "experiment_exposure";

export function trackEvent(
  name: EventName | string,
  properties: Record<string, unknown> = {}
) {
  if (typeof window === "undefined") return;
  if (!hasConsent()) return;

  // Home A/B bucket (cookie set by the inline script in index.html), on every event.
  const variant = currentVariant();
  const rows = [
    {
      event_name: name,
      session_id: getSessionId(),
      page_path: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      properties: (variant ? { ...properties, variant } : properties) as never,
    },
  ];
  // One exposure per session, sent with the first consented event.
  if (variant && !sessionStorage.getItem(EXPOSURE_KEY)) {
    sessionStorage.setItem(EXPOSURE_KEY, variant);
    rows.unshift({ ...rows[0], event_name: "experiment_exposure", properties: { experiment: EXPERIMENT_ID, variant } as never });
  }

  // Fire-and-forget. Don't await. Lazy-load supabase so it isn't on the critical path.
  void import("@/integrations/supabase/client").then(({ supabase }) =>
    supabase
      .from("analytics_events")
      .insert(rows)
      .then(({ error }) => {
        if (error && import.meta.env.DEV) {
          // eslint-disable-next-line no-console
          console.warn("[analytics] insert failed", error.message);
        }
      })
  );

}
